import template from './image.html';
import controller from './image.controller';
import './image.scss';

let imageComponent = {
  bindings: {
    article: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default imageComponent;



// WEBPACK FOOTER //
// ./client/app/components/content-types/image/image.component.js